class SubcollectionHero extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;

      e.preventDefault();

      const targetEl = document.querySelector(link.getAttribute("href"));

      if (!targetEl) return;

      window.scrollTo({
        top: targetEl.offsetTop - 60,
        behavior: "smooth",
      });
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("subcollection-hero")) {
  customElements.define("subcollection-hero", SubcollectionHero);
}
